var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import * as React from 'react'; // polyfill

import 'focus-visible';
import { Global, css } from '@emotion/core';
export var FocusVisible = function FocusVisible() {
  return /*#__PURE__*/React.createElement(Global, {
    styles: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        .js-focus-visible *:focus:not(.focus-visible) {\n          box-shadow: none;\n          outline: 0;\n        }\n      "])))
  });
};
export default FocusVisible;